<template>
  <div
    class="tabs"
    :class="{ '--is-vertical' : orientation === 'vertical' }"
  >
    <ul class="tabs__list">
      <li
        v-for="(item, index) in data"
        :key="index"
        @click="tabChange(index)"
        class="tabs__item"
        :class="{ '--is-active' : activeIndex === index }"
      >
        <span
          v-html="item.icon"
          class="tabs__icon"
        ></span>

        <div class="tabs__text">
          <span
            v-html="item.title"
            class="tabs__title"
          ></span>

          <span
            v-if="orientation === 'vertical' && item.description"
            v-html="item.description"
            class="tabs__description"
          ></span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
// import FancyHeading from '@/components/Pages/FancyHeading';

export default {
  name: 'Tabs',
  props: {
    data: {
      type: Array
    },
    orientation: {
      type: String,
      default: 'horizontal'
    }
  },
  components: {
  },
  data: function () {
    return {
      activeIndex: 0
    };
  },
  methods: {
    tabChange (index) {
      this.activeIndex = index;
      this.$emit('change', index);
    }
  },
  created () {
  },
  mounted () {
  }
};
</script>

<style lang="scss" scoped>
/**
 * Tabs
 *
 * @author juanpablob <m.juanpablob@gmail.com>
 * @desc Content tabs
 * @since 2022-06-29
**/

$component: 'tabs';

.#{$component} {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid $sky;

  &__list {
    @include unlist;
    display: flex;
  }

  &__item {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    align-content: flex-start;
    @include rfs(14rem, max-width);
    @include padding-bottom(map-get($spacers, 3));
    color: $ink-lightest;
    @include font-size(map-get($lp, 'font-size-base'));
    line-height: 1.2;
    text-align: center;
    cursor: pointer;
    transition: all 0.1s ease-in-out;

    &:not(:first-child) {
      @include margin-left(map-get($spacers, 6));
    }

    &:after {
      content: '';
      display: block;
      position: absolute;
      bottom: -4px;
      left: 0;
      right: 0;
      width: 100%;
      height: 4px;
      background-color: transparent;
    }

    @include hover () {
      color: $ink-lighter;
    }

    &:active {
      color: $ink-light;
      transition: none;
    }

    &.--is-active {
      &:after {
        background-color: var(--color-active);
      }
      .#{$component} {
        &__icon,
        &__title {
          color: var(--color-active);
        }

        &__title {
          font-weight: $font-weight-bold;
        }

        &__description {
          color: $ink;
        }
      }
    }
  }

  &__icon {
    flex-shrink: 0;
    @include rfs(3rem, width);
    min-width: 2rem;
    @include margin-bottom(map-get($spacers, 3));
  }

  &__title {
    // @include padding(0 map-get($spacers, 1));
  }

  &__description {
    display: none;
  }

  /** RESPONSIVENESS **/

  // ——————————————————————————————
  // Max LG
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-lg')) {

  }

  @media (min-width: map-get($lp, 'viewport-md')) {
    /** Vertical orientation, only available for md viewport and above **/
    &.--is-vertical {
      justify-content: flex-start;
      border-bottom: none;

      .#{$component} {
        &__list {
          flex-direction: column;
        }

        &__item {
          max-width: 80%;
          flex-direction: row;
          align-items: center;
          @include padding(map-get($spacers, 3) 0 map-get($spacers, 3) 0);
          border-bottom: 1px solid rgba($ink, 0.1);
          text-align: left;

          &:after {
            display: none;
          }

          &:not(:first-child) {
            margin-left: 0;
          }

          &:not(:last-child) {
          }
        }

        &__icon {
          flex-shrink: 0;
          margin-bottom: 0;
          @include margin-right(map-get($spacers, 3));
        }

        &__text {
          display: flex;
          flex-direction: column;
        }

        &__title {
          ::v-deep {
            br {
              display: inline;
              content: ' ';

              &:after {
                content: ' ';
              }
            }
          }
        }

        &__description {
          display: block;
          @include margin-top(map-get($spacers, 1));
          @include font-size(map-get($lp, 'font-size-sm'));
          line-height: 130%;
          font-weight: $font-weight-light;
        }
      }
    }
  }

  // ——————————————————————————————
  // Max MD
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-md')) {
  }

  // ——————————————————————————————
  // Max SM
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-sm')) {
  }

  // ——————————————————————————————
  // Max XS
  // ——————————————————————————————
  @media (max-width: map-get($lp, 'viewport-xs')) {
    justify-content: flex-start;
    overflow-x: scroll;
    overflow-y: hidden;
    ms-overflow-style: none;
    scrollbar-width: none;
    @include margin-right(- map-get($spacers, 5));
    @include padding-right(map-get($spacers, 5));

    &::-webkit-scrollbar {
      display: none;
    }

    &__list {
    }

    &__item {
      @include rfs(8rem, min-width);

      &:after {
        bottom: 0;
      }
    }

    &__icon {
      @include margin-bottom(map-get($spacers, 1));
    }

    &__title {
      ::v-deep {
        br {
          display: inline;
          content: ' ';

          &:after {
            content: ' ';
          }
        }
      }
    }
  }
}
</style>
